export * from './types';
export * from './bridge';
import { google } from './reexport/google';
import { emailTemplates } from './reexport/emailTemplates';
import { events } from './reexport/events';
import { accounts } from './reexport/accounts';
import { applicationsGroups } from './reexport/applicationsGroups';
import { users } from './reexport/users';
export const rpcServiceClient = {
    google,
    emailTemplates,
    events,
    accounts,
    applicationsGroups,
    users,
};
